<template>
  <v-layout wrap>
    <v-flex xs12>
      <span class="body-2">{{ title }}</span>
    </v-flex>
    <v-flex xs12 class="mt-1">
      <span class="display-1" v-if="currency">{{ value | currency('£', ',', 0) }}</span>
      <span class="display-1" v-else>{{ value.toLocaleString('en') }}</span>
    </v-flex>
    <v-flex xs12>
      <v-icon v-if="diffDirection === 'up'" color="green">fas fa-caret-up</v-icon>
      <v-icon v-if="diffDirection === 'down'" color="red">fas fa-caret-down</v-icon>
      <v-icon v-if="diffDirection === 'horizontal'">fas fa-arrows-alt-h</v-icon>
      <span class="caption green--text text--darken-2" v-if="diffDirection === 'up'">{{ diff }}%</span>
      <span class="caption red--text" v-if="diffDirection === 'down'">{{ diff }}%</span>
      <span class="caption" v-if="diffDirection === 'horizontal'">{{ diff }}%</span>
      <!--<span class="caption" v-if="currency">{{ previousValue | currency('£', ',', 0) }}</span>-->
      <!--<span class="caption" v-else>{{ previousValue.toLocaleString('en') }}</span>-->
    </v-flex>
  </v-layout>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'StatsTab',
  props: ['title', 'value', 'previousValue', 'currency'],
  computed: {
    diff: function() {
      let diff = _.round(this.value / this.previousValue, 2);

      return diff >= 100 ? diff - 100 : -diff;
    },
    diffDirection: function() {
      if (this.value > this.previousValue) {
        return 'up';
      }

      if (this.value < this.previousValue) {
        return 'down';
      }

      return 'horizontal';
    }
  }
};
</script>

<style type="scss" scoped></style>
